import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { debounce } from 'lodash-es';
import { Button, Col, Collapse, Input, Row } from 'reactstrap';
import { parsePriceValue } from 'site-modules/shared/utils/price-utils';
import { MORE_INFO } from 'site-modules/shared/constants/appraisal/appraisal';

export class AppraisalReportStepPayoffAmount extends Component {
  state = { isMoreInfoCollapsed: false };

  componentWillUnmount() {
    this.debouncedPayoffChange.cancel();
  }

  debouncedPayoffChange = debounce(amount => {
    this.props.onPayoffChange(amount);
  }, 250);

  handlePayoffChange = e => {
    e.persist();
    const amountValue = parsePriceValue(e.target.value);
    const amount = amountValue > 0 ? -amountValue : amountValue;

    this.props.onChange(amount);
    this.debouncedPayoffChange(amount);
  };

  toggleMoreInfo = () => this.setState(prevState => ({ isMoreInfoCollapsed: !prevState.isMoreInfoCollapsed }));

  render() {
    const { isMoreInfoCollapsed } = this.state;
    const { value } = this.props;

    return (
      <Row>
        <Col xs={7}>
          <span id="payoff-amount" className="fw-normal mb-1">
            Do you owe anything on your trade-in?
          </span>
        </Col>
        <Col xs={5}>
          <div className="payment-field ms-md-1 pos-r">
            <span className="i-dollar">$</span>
            <Input
              name="payOffAmount"
              type="number"
              inputMode="numeric"
              className="input-content text-gray-darker text-end ps-1 pe-0"
              onChange={this.handlePayoffChange}
              value={value}
              data-testid="payOffAmount"
            />
          </div>
        </Col>

        <Col>
          <Button
            color="link"
            aria-describedby="total-trade-in"
            aria-expanded={!isMoreInfoCollapsed}
            className="p-0 mt-0_25 text-decoration-none text-start heading-6 fw-normal"
            onClick={this.toggleMoreInfo}
          >
            <div className="text-primary-darker">
              <span>{MORE_INFO.title}</span>
              <span
                className={classNames('ps-0_25 small text-primary-darker', {
                  'icon icon-arrow-down2': !isMoreInfoCollapsed,
                  'icon icon-arrow-up2': isMoreInfoCollapsed,
                })}
                aria-hidden
              />
            </div>
          </Button>
          <Collapse className="mt-0_75" aria-hidden={isMoreInfoCollapsed} isOpen={isMoreInfoCollapsed}>
            <p className="text-gray-darker">{MORE_INFO.PAYOFF_AMOUNT}</p>
          </Collapse>
        </Col>
      </Row>
    );
  }
}
AppraisalReportStepPayoffAmount.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onPayoffChange: PropTypes.func.isRequired,
};
